import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { UserDataService } from '../features/user-data.service';
import { AngularFireFunctions } from '@angular/fire/functions';
import { first} from 'rxjs/operators';
import {pipe}from 'rxjs'
import { MailCenterService } from './mail-center.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mail-center',
  templateUrl: './mail-center.component.html',
  styleUrls: ['./mail-center.component.css']
})

export class MailCenterComponent implements OnInit {
token:string="";
  companyData: any;
  keyCode: any;
  inventionDetailData: any;
  inventorData: any;
  inventionName: any;
  documentNumber: any;
  inventionDate: any;
  inventionStatus: any;
  lastInventionStatus: any="1";
  status: any;
  visible: any;
  message:any;

  //Country
  number=0;
  selectedCountry:any=[];
  countryLastStatus:any;
  countryStatusList:any;
  patentInfo:any;
  countryDocLink:any=[];
  constructor(private userData:UserDataService, private user:AuthService, private fns: AngularFireFunctions, private mailService:MailCenterService, private route:Router) {
    this.token = this.user.token;

  }

  ngOnInit(): void {

  }
  ngAfterContentInit(): void {
    this.number=this.userData.number;
    this.keyCode=this.userData.key;
    this.userData.inventionDetail(this.keyCode).
    subscribe(res=>
      {//console.log(res);
      this.inventionDetailData=res;
      this.companyData=this.inventionDetailData[0].CompanyData;
      this.inventorData=this.inventionDetailData[0].inventorData;
      this.inventionName=this.inventionDetailData[0].inventionName;
      this.documentNumber=this.inventionDetailData[0].documentNumber;
      this.inventionDate=this.inventionDetailData[0].inventionDate;
      this.inventionStatus=this.inventionDetailData[0].status;
      //console.log(this.inventionStatus);

      //this.status=this.inventionDetailData[0].status.slice(-1)[0];
      this.status=this.inventionDetailData[0].status.slice(-1)[0].status;
      this.visible=true;


       //Country records
       this.patentInfo=this.inventionDetailData[0].hasOwnProperty('patentInfo') ? this.patentInfo= this.inventionDetailData[0].patentInfo : this.patentInfo=[];

       if (this.number<0) {
         this.selectedCountry=[];
         this.countryStatusList=[];
         this.countryLastStatus="";
         this.countryDocLink=[];
      }else {
        this.selectedCountry=this.patentInfo[this.number];
        this.countryStatusList=this.selectedCountry.patentStatus;
        this.countryLastStatus=this.selectedCountry.patentStatus.slice(-1)[0].status;
        this.countryDocLink=this.selectedCountry.hasOwnProperty('countryDocLink')? this.countryDocLink= this.selectedCountry.countryDocLink : this.countryDocLink=[];
      }


      })
      }
     /*
          this.companyData=this.inventionDetailData[0].CompanyData;
          this.inventorData=this.inventionDetailData[0].inventorData;
          this.status=this.inventionDetailData[0].status.slice(-1)[0].status;
          this.statusList=this.inventionDetailData[0].status;
          this.inventionName=this.inventionDetailData[0].inventionName;
          this.documentNumber=this.inventionDetailData[0].documentNumber;
          this.inventionDate=this.inventionDetailData[0].inventionDate;
          this.docLink=this.inventionDetailData[0].hasOwnProperty('docLink') ? this.docLink= this.inventionDetailData[0].docLink : this.docLink=[];
          this.visible=true;

          //Country records
          this.patentInfo=this.inventionDetailData[0].hasOwnProperty('patentInfo') ? this.patentInfo= this.inventionDetailData[0].patentInfo : this.patentInfo=[];
          this.selectedCountry=this.patentInfo[this.number];
          this.countryStatusList=this.selectedCountry.patentStatus;
          this.countryLastStatus=this.selectedCountry.patentStatus.slice(-1)[0].status;
          this.countryDocLink=this.selectedCountry.hasOwnProperty('countryDocLink')? this.countryDocLink= this.selectedCountry.countryDocLink : this.countryDocLink=[];


          })
          }*/

  sendInvStatusMail1Person(mail:string,name1:string,share:string){
    const time=(Math.round(Date.now()/1000));
    const date = new Date(this.inventionDate);
    console.log(date); //
    const unixTimestamp = Math.floor(date.getTime() / 1000);
    console.log(unixTimestamp); // Invention date in unixtimestamp

    const reminder= [unixTimestamp, unixTimestamp+2628000,unixTimestamp+3942000, unixTimestamp+4599000 ]  // Buluş tarihinden 1 Ay, 1,5 ay, 1,75 ay sonra
    this.visible=false;
        // Angular Fire - Converts Promise to Observable
  /*this.fns.httpsCallable('genericEmail')({ name:name1, text: 'Your invention named as '+this.inventionName+" has a status update. The current status of your invention is "+this.status+".Your share in the invention is "+ share+"/100",email:["utuzer@sisecam.com",mail] })
  .pipe(first())
  .subscribe(resp => {
    console.log({ resp });
  }, err => {
    console.error({ err });
  });*/
    this.mailService.sendStatusUpdate(name1, this.inventionName, this.status, share,mail,time).pipe(first())
    .subscribe(resp => {
      //console.log({ resp });
      this.message="e-posta gönderilmiştir";
      alert("e-posta gönderilmiştir")
    }, err => {
      console.error({ err });

    });
    if (this.status=="Taslak Buluş" || this.status=="Kabul Edilmiş Buluş") {
    this.mailService.demandforrightReminder(this.inventionDate,this.inventionName, this.status, reminder).pipe(first())
    .subscribe(resp => {
      //console.log({ resp });
      this.message="e-posta gönderilmiştir";
      alert("15 gün, 1 ay ve 1,5 ay sürelerinde karar girişinin yapılması için hatırlatma yapılacaktır")
    }, err => {
      console.error({ err });

    });
  }
  }
  navigate(){this.route.navigate(['patentList/',this.inventionDetailData[0].documentNumber]);
  this.userData.getKey(this.keyCode);}
  sendInvStatusMailtoAll(){
    const time=(Math.round(Date.now()/1000));
    const date = new Date(this.inventionDate);
    const unixTimestamp = Math.floor(date.getTime() / 1000);
    const reminder= [unixTimestamp, unixTimestamp+2628000,unixTimestamp+3942000, unixTimestamp+4599000 ]  // Buluş tarihinden 1 Ay, 1,5 ay, 1,75 ay sonra
    this.visible=false;

    if (this.status=="Taslak Buluş" || this.status=="Kabul Edilmiş Buluş") {
      this.mailService.demandforrightReminder(this.inventionDate,this.inventionName, this.status, reminder).pipe(first())
      .subscribe(resp => {
        //console.log({ resp });
        this.message="e-posta gönderilmiştir";
        alert("15 gün, 1 ay ve 1,5 ay sürelerinde karar girişinin yapılması için hatırlatma yapılacaktır")
      }, err => {
        console.error({ err });

      });
    }
    for (var val of this.inventorData) {
      let shareText=""
      if (val.share<1) {shareText="henüz belirtilmemiştir." } else {shareText=val.share+"/100"};
      this.mailService.sendStatusUpdate(val.name, this.inventionName, this.status, val.share,val.mail,time)
      .pipe(first())
      .subscribe(resp => {
       // console.log({ resp });
        this.message="e-posta gönderilmiştir";
        alert("e-posta gönderilmiştir")
      }, err => {
        console.error({ err });
      });
    }
  }



}
